import React, { useEffect, useState } from "react";
import axios from "axios";
import ReactModal from "react-modal";
import TextField from "@mui/material/TextField";
import Swal from "sweetalert2";
import dayjs from "dayjs";

function EditarProgramacionHoraria({ idEvento, datosActuales, onUpdate }) {
  const [modalIsOpen, setIsOpen] = useState(false);

  const [formData, setFormData] = useState({
    servicio: "",
    actividad: "",
    observaciones: "",
    cumplimiento: "",
    horario: "",
  });

  // 🔥 Normaliza datetime-local
  const normalizeDateTime = (value) =>
    value ? dayjs(value).format("YYYY-MM-DDTHH:mm") : "";

  // 🔥 Cargar datos cuando se abre el modal
  useEffect(() => {
    if (modalIsOpen) {
      setFormData({
        servicio: datosActuales.servicio || "",
        actividad: datosActuales.actividad || "",
        observaciones: datosActuales.observaciones || "",
        cumplimiento: datosActuales.cumplimiento || "En Revisión",
        horario: normalizeDateTime(datosActuales.horario),
      });
    }
  }, [modalIsOpen, datosActuales]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // 🔥 Envía SOLO los campos modificados
  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {};

    if (formData.servicio !== datosActuales.servicio)
      payload.servicio = formData.servicio;

    if (formData.actividad !== datosActuales.actividad)
      payload.actividad = formData.actividad;

    if (formData.observaciones !== datosActuales.observaciones)
      payload.observaciones = formData.observaciones;

    if (formData.cumplimiento !== datosActuales.cumplimiento)
      payload.cumplimiento = formData.cumplimiento;

    if (
      normalizeDateTime(formData.horario) !==
      normalizeDateTime(datosActuales.horario)
    ) {
      payload.horario = dayjs(formData.horario).toISOString();
      payload.fecha = formData.horario.split("T")[0];
    }

    if (Object.keys(payload).length === 0) {
      Swal.fire("ℹ️ Sin cambios", "No hay cambios para actualizar", "info");
      return;
    }

    try {
      await axios.put(
        `https://suadesarrollo.azurewebsites.net/api/EditaProgramacion/${idEvento}`,
        payload,
        {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
        },
      );

      Swal.fire(
        "✅ Actualizado",
        "Evento actualizado correctamente",
        "success",
      );

      setIsOpen(false);
      onUpdate(); // 🔥 el padre vuelve a consultar la API
    } catch (error) {
      console.error("Error al actualizar", error);
      Swal.fire("❌ Error", "No se pudo actualizar el evento", "error");
    }
  };

  return (
    <>
      <button
        className="btn btn-secondary btn-sm"
        onClick={() => setIsOpen(true)}
      >
        Editar
      </button>

      <ReactModal isOpen={modalIsOpen} onRequestClose={() => setIsOpen(false)}>
        <br></br>
        <h5 className="text-primary mb-3">Editar visita / evento</h5>

        <form onSubmit={handleSubmit}>
          <input
            className="form-control mb-2"
            placeholder="Servicio"
            name="servicio"
            value={formData.servicio}
            onChange={handleChange}
          />

          <input
            className="form-control mb-2"
            placeholder="Actividad"
            name="actividad"
            value={formData.actividad}
            onChange={handleChange}
          />

          <input
            className="form-control mb-2"
            placeholder="Observaciones"
            name="observaciones"
            value={formData.observaciones}
            onChange={handleChange}
          />

          <TextField
            label="Fecha y hora"
            type="datetime-local"
            name="horario"
            value={formData.horario}
            onChange={handleChange}
            fullWidth
            InputLabelProps={{ shrink: true }}
          />

          <select
            className="form-control mt-2"
            name="cumplimiento"
            value={formData.cumplimiento}
            onChange={handleChange}
          >
            <option value="En Revisión">En Revisión</option>
            <option value="Sí">Sí</option>
            <option value="No">No</option>
          </select>

          <div className="text-end mt-3">
            <button
              type="button"
              className="btn btn-secondary me-2"
              onClick={() => setIsOpen(false)}
            >
              Cancelar
            </button>
            <button type="submit" className="btn btn-primary">
              Guardar cambios
            </button>
          </div>
        </form>
      </ReactModal>
    </>
  );
}

export default EditarProgramacionHoraria;
